import React, {useState, useEffect} from 'react';
import './SharedFilesList.css';
import axios from "axios";
import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Backdrop, Tooltip
} from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {useLocation} from "react-router-dom";
import PermitTypeDisplayForAdmin from "../../components/CaseInsideTable/PermitTypeDisplayForAdmin";
import {findStatusTitleById} from "../../enums/CaseStatus";
import LoaderCustomFixed from "../../components/ConfirmationModal/LoaderCustomFixed";

const SharedFilesList = () => {
    const location = useLocation();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [caseData, setCaseData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);

    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    const useQuery = () => {
        return new URLSearchParams(location.search);
    };
    const query = useQuery();
    const caseID = query.get('caseId');

    useEffect(() => {
        let didCancel = false;

        const fetchData = async () => {
            try {

                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser`, {
                    params: {
                        Id: caseID
                    },
                });
                if (response.data.success) {
                    setCaseData(response.data.data);
                }


            } catch (error) {
            } finally {
                if (!didCancel) {
                    setIsLoading(false);
                }
            }
        };

        void fetchData();

        return () => {
            didCancel = true;
        };
    }, [caseID]);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const fileIds = query.get('id');
        if (fileIds) {
            const ids = fileIds.split(',').map(id => ({id: parseInt(id, 10)}));
            setSelectedFiles(ids);
        }
    }, [location]);

    const handleDownload = async () => {
        setIsDownloading(true);
        const payload = {
            casefileIds: selectedFiles.map(file => file.id)
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CaseFilesDocumentsDownloadZip`, payload, {
                responseType: 'blob',
            });

            const file = new Blob([response.data], {type: 'application/zip'});
            const fileURL = URL.createObjectURL(file);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "განაცხადი N" + caseData.caseNumber);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.parentNode.removeChild(fileLink);
        } catch (error) {
            console.error("Error downloading files", error);
        } finally {
            setIsDownloading(false);
        }
    };

    return (

        <div>
            {isLoading ? (<div style={{paddingTop: 300, paddingBottom: 300}}><LoaderCustomFixed/></div>) : (
                <div className={"centered-container"}>
                <div className="shared-files-container">
                    <Backdrop open={isDownloading} style={{zIndex: 1000}}>
                        <CircularProgress color="inherit"/>
                    </Backdrop>


                    <div>
                        {caseData && (<PermitTypeDisplayForAdmin id={caseData.permitTypeId}/>)}
                        {caseData && (
                            <TableContainer className={"answers-inside-info-table"} component={Paper}>
                                <Table aria-label="case data table">
                                    <TableHead className={"answers-inside-info-table-header"}>
                                        <TableRow>
                                            <TableCell align="center">განაცხადის ნომერი</TableCell>
                                            <TableCell align="center">სტატუსი</TableCell>
                                            <TableCell align="center">რეგიონი</TableCell>
                                            <TableCell align="center">მუნიციპალიტეტი</TableCell>
                                            <TableCell align="center">საკრებულო</TableCell>
                                            <TableCell align="center">დასახლებული პუნქტი</TableCell>
                                            <TableCell align="center">განაცხადის თარიღი</TableCell>
                                            <TableCell align="center">დასრულების თარიღი</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center">{caseData.caseNumber}</TableCell>
                                            <TableCell align="center">{findStatusTitleById(caseData.status)}</TableCell>
                                            <TableCell align="center">{caseData.regionsNames}</TableCell>
                                            <TableCell align="center">{caseData.citysNames}</TableCell>
                                            <TableCell align="center">{caseData.councilsNames}</TableCell>
                                            <TableCell align="center">{caseData.populatedAreasNames}</TableCell>
                                            <TableCell align="center">{formatDate(caseData.createDate)}</TableCell>
                                            <TableCell align="center">{formatDate(caseData.dedline)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </div>

                    <header>
                        <h1>განაცხადის ფაილები</h1>
                        <p>დააჭირეთ ღილაკს დაბლა დოკუმენტების ZIP არქივის გადმოწერისთვის</p>
                    </header>
                    <Tooltip title={"განმაცხადის დოკუმენტაციის გადმოწერა"}>
                        <div className="button-container">
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<CloudDownloadIcon/>}
                                onClick={handleDownload}
                                disabled={isDownloading}
                                style={{width: 250}}
                            >
                                {isDownloading ? "გთხოვთ დაელოდოთ..." : "გადმოწერა"}
                            </Button>
                        </div>
                    </Tooltip>
                </div>
                </div>
            )}


        </div>

    );
};

export default SharedFilesList;
